import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/** PD-16339 — tags on a media item (many per item). */
@Index('idx_media_asset_tag_asset', ['fkMediaAssetId'])
@Index('idx_media_asset_tag_tag', ['fkMediaTagId'])
@Entity('media_asset_tag')
export class MediaAssetTagEntity extends BaseEntity {
	@Column('int', { name: 'fk_media_asset__id', unsigned: true })
	public fkMediaAssetId!: number;

	@Column('int', { name: 'fk_media_tag__id', unsigned: true })
	public fkMediaTagId!: number;
}
